import React from 'react';
import { MISTAKES_HEADLINE, MISTAKES_STATEMENT_BOTTOM, MISTAKES_STATEMENT_TOP, mistakes } from '../data/poolContent';
export function MistakesSection() {
  return <section className="w-full bg-abyss-950 py-14 sm:py-20" aria-labelledby="mistakes-title" data-id="element-221" data-mp="1txlzj935vfxb">
      <div className="mx-auto max-w-5xl px-5" data-id="element-222" data-mp="1oyj3uf92mm20">
        <h2 id="mistakes-title" className="mx-auto max-w-3xl text-center font-display text-[2rem] font-bold uppercase leading-none text-frost-50 sm:text-[2.8rem]" data-id="element-223" data-mp="1ozkj6vx4dupj">
          {MISTAKES_HEADLINE}
        </h2>

        <ol className="mt-10 divide-y divide-abyss-600 border-y border-abyss-600" data-id="element-224" data-mp="2hl3sh7y5wk1v">
          {mistakes.map((m, i) => <li key={m.title} className="grid gap-3 py-7 sm:grid-cols-[9rem_1fr] sm:gap-8" data-id="element-225" data-mp="27p97i66gucvx" data-mpi={i}>
              <p className="font-display text-[1rem] font-bold uppercase tracking-[0.14em] text-alert" data-id="element-226" data-mp="118x7dzk32kxp">
                Mistake #{i + 1}
              </p>
              <div data-id="element-227" data-mp="w8ai6dfbtjio">
                <h3 className="font-display text-[1.6rem] font-bold uppercase leading-[1.05] text-frost-50 sm:text-[1.9rem]" data-id="element-228" data-mp="wbychesli9yg">
                  {m.title}
                </h3>
                <p className="mt-2 max-w-2xl text-[15px] leading-relaxed text-body" data-id="element-229" data-mp="ljtmnwilwqgg">{m.body}</p>
              </div>
            </li>)}
        </ol>

        <p className="mx-auto mt-14 max-w-3xl text-center font-display text-[2rem] font-bold uppercase leading-[1.02] text-frost-50 sm:text-[3rem]" data-id="element-230" data-mp="bmp2u3c8h72t">
          {MISTAKES_STATEMENT_TOP}
          <span className="block text-aqua" data-id="element-231" data-mp="2mad8rs8l5ti">{MISTAKES_STATEMENT_BOTTOM}</span>
        </p>
      </div>
    </section>;
}